<section class="faq">
  <h2 class="title">{{ 'faq' | translate }}</h2>

  <div class="faq-grid">
    <mat-accordion class="column">
      <mat-expansion-panel
        *ngFor="let item of dataFAQ1; let i = index"
        class="custom-panel"
        [expanded]="item.expanded"
        (opened)="onToggle('dataFAQ1', i)"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ item.question | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p>{{ item.answer | translate }}</p>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion class="column">
      <mat-expansion-panel
        *ngFor="let item of dataFAQ2; let i = index"
        class="custom-panel"
        [expanded]="item.expanded"
        (opened)="onToggle('dataFAQ2', i)"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ item.question | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p>{{ item.answer | translate }}</p>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</section>
